import { httpCollection } from "us.helper/http/collection";

export default {
  closureCode: {
    get: (params: any): Promise<any> => {
      return new Promise<any>(async (resolve, reject) => {
        try {
          const { data, status } = await httpCollection.get(
            "entityservice",
            "closurecodes",
            {}
          );
          resolve({ data, status });
        } catch (error) {
          reject(error);
        }
      });
    },
    add: (params: any): Promise<any> => {
      return new Promise<any>(async (resolve, reject) => {
        try {
          const { data, status } = await httpCollection.post(
            "entityservice",
            "closurecode",
            params
          );

          resolve({ data, status });
        } catch (error) {
          reject(error);
        }
      });
    },
    update: (params: any): Promise<any> => {
      return new Promise<any>(async (resolve, reject) => {
        try {
          const { data, status } = await httpCollection.put(
            "entityservice",
            "closurecode",
            params
          );

          resolve({ data, status });
        } catch (error) {
          reject(error);
        }
      });
    },
    delete: (params: any): Promise<any> => {
      return new Promise<any>(async (resolve, reject) => {
        try {
          const { data, status } = await httpCollection.delete(
            "entityservice",
            "closurecode",
            params?.codeId
          );

          resolve({ data, status });
        } catch (error) {
          reject(error);
        }
      });
    },
  },
  history: {
    get: (params: any): Promise<any> => {
      return new Promise<any>(async (resolve, reject) => {
        try {
          const { data, status } = await httpCollection.get(
            "entityservice",
            `closurecodechnagelog/${params?.codeId}`,
            {}
          );
          resolve({ data, status });
        } catch (error) {
          reject(error);
        }
      });
    },
  },
};
